// ─────────────────────────────────────────────────────────────────────────────
// mock-board-configs-legacy.ts
// Configuración para tableros tipo 'dynamic' (solo charts/stats).
// ─────────────────────────────────────────────────────────────────────────────

import { BoardConfig } from './board-config.model';

export const MOCK_BOARD_CONFIGS: Record<string, BoardConfig> = {};
